import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { PRE_AUTH_PATH_KEY } from '@@common';

/**
 * Component that handles path restoration after authentication.
 * Must be placed inside Router context to use useNavigate.
 */
const PathRestoration: React.FC = () => {
	const navigate = useNavigate();

	useEffect(() => {
		// Check if there's a path to restore from sessionStorage
		const pathToRestore = sessionStorage.getItem(PRE_AUTH_PATH_KEY);

		if (pathToRestore) {
			sessionStorage.removeItem(PRE_AUTH_PATH_KEY);
		}

		if (pathToRestore && pathToRestore !== window.location.pathname + window.location.search) {
			console.log('Restoring path after authentication:', pathToRestore);

			// Use React Router navigation instead of window.location
			navigate(pathToRestore, { replace: true });
		}
	}, [navigate]);

	// This component doesn't render anything
	return null;
};

export default PathRestoration;
